import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'antd';
import GeneralSpeechEvaluationItem from './GeneralSpeechEvaluationItem';
import ApplicationScenariosLess from './ApplicationScenarios.less';
import GeneralSpeechEvaluationLess from './GeneralSpeechEvaluation.less';

const GeneralSpeechEvaluation = ({ abilityList }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const CarouselRef = useRef(null);
  const ScenesRef = useRef(null);
  const carouselSettings = {
    swipeToSlide: false,
    swipe: false,
    dots: false,
    touchMove: false
  };
  const generalSpeechEvaluationRef = useRef(null);

  const changeCurrentIndex = (num) => {
    if (currentIndex.toString() !== num.toString()) {
      generalSpeechEvaluationRef.current.init();
    }
    setCurrentIndex(num);
    CarouselRef.current.goTo(num, true);
  };

  return (
    <div className={GeneralSpeechEvaluationLess.generalSpeechEvaluation}>
      <div
        className={
          ApplicationScenariosLess.scenesBox +
          ' ' +
          GeneralSpeechEvaluationLess.scenesBox
        }
        ref={ScenesRef}
      >
        <div
          className={
            ApplicationScenariosLess.scenesTypesBox +
            ' ' +
            GeneralSpeechEvaluationLess.scenesTypesBox
          }
        >
          {abilityList.map((content) => {
            return (
              <div
                key={content.inx}
                className={
                  ApplicationScenariosLess.scenesType +
                  ' ' +
                  (currentIndex.toString() === content.inx &&
                    ApplicationScenariosLess.active)
                }
                onClick={() => changeCurrentIndex(content.inx)}
              >
                {content.title}
                <span
                  className={
                    ApplicationScenariosLess.bottomLine +
                    ' ' +
                    GeneralSpeechEvaluationLess.bottomLine
                  }
                />
              </div>
            );
          })}
        </div>
        <Carousel ref={CarouselRef} {...carouselSettings} effect="fade">
          {abilityList.map((content) => {
            return (
              <div key={content.inx}>
                <div className={GeneralSpeechEvaluationLess.scenesContent}>
                  <GeneralSpeechEvaluationItem
                    abilityContent={content}
                    generalSpeechEvaluationRef={generalSpeechEvaluationRef}
                  />
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

GeneralSpeechEvaluation.propTypes = {
  abilityList: PropTypes.arrayOf(
    PropTypes.shape({
      inx: PropTypes.string,
      title: PropTypes.string,
      result: PropTypes.array
    })
  )
};

export default GeneralSpeechEvaluation;
